import React from "react";
import {TableCell, Typography, Grid} from "@material-ui/core";
import {observer, inject} from "mobx-react";
import {computed} from "mobx";
import {IValuesStore} from "Stores/Values/types";
import {Permission} from "@src/Interfaces/Entity/Permission";
import EntityDelete from "@src/Components/Common/EntityDelete/EntityDelete";
import {IManagementStore} from "@src/Stores/Management/types";
import {STTableRow} from "@src/Components/Ui/STTableRow";
import {IAuthStore} from "@src/Stores/Auth/types";
import {STTableCellTypography} from "@src/Components/Ui/STTableCellTypography";
import {Values} from "Tools/Values";
import CreateIcon from "@material-ui/icons/Create";
import RoundButton from "@src/Shared/Components/RoundButton/RoundButton";

interface IProps {
    auth?: IAuthStore;
    permission: Permission;
    values?: IValuesStore;
    management?: IManagementStore;
    onEditButtonClick: () => void;
}

@inject("auth", "values", "management")
@observer
class PermissionTableItem extends React.Component<IProps> {
    @computed get isActive() {
        return this.props.permission.state === this.props.values.states.Active;
    }

    @computed get adminPermission() {
        return this.props.values.common["AdminPermissionId"];
    }

    handleRemove = async () => {
        await this.props.management.removePermission(this.props.permission.id);
    };

    render() {
        const permission: Permission = this.props.permission;
        return (
            <STTableRow className={"management-table-row"} hover isActive={this.isActive}>
                <TableCell component="th" scope="row" size="small">
                    <Typography>
                        <STTableCellTypography>{permission.name}</STTableCellTypography>
                    </Typography>
                </TableCell>
                <TableCell size="small">
                    <STTableCellTypography>{permission.description}</STTableCellTypography>
                </TableCell>
                <TableCell align="right" size="small">
                    <Grid container wrap="nowrap" justify="flex-end">
                        {this.props.auth.user.location.primary && (this.adminPermission != permission.id) && (
                            <>
                                <RoundButton
                                    icon={<CreateIcon/>}
                                    tooltipTitle={Values.getLocalizationValue("edit")}
                                    onClick={() => this.props.onEditButtonClick()}
                                />
                                <EntityDelete onSubmit={this.handleRemove}/>
                            </>
                        )}
                    </Grid>
                </TableCell>
            </STTableRow>
        );
    }
}

export default PermissionTableItem;
